// extracted by mini-css-extract-plugin
export default {"Error":"ErrorBoundary_Error__Xq5s1","SignBttn":"ErrorBoundary_SignBttn__AhaUH"};